module.exports = __webpack_public_path__ + "static/img/SearchDetailMarriage1.0673d35.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailMarriage1.png
// module id = 743
// module chunks = 0